import React from 'react'
import Navbar from '../Header/Navbar'
import AssestHero from './AssetTagging/AssestHero'
import AssestSection from './AssetTagging/AssestSection'
import AssestTrust from './AssetTagging/AssestTrust'
import Footer from '../Footer/Footer'

function AssetTagging() {
    return (
        <div>
            <AssestHero/>
            <AssestSection/>
            <AssestTrust/>
            <Footer/>
        </div>
    )
}

export default AssetTagging
